module.exports = __webpack_public_path__ + "img/24.bf09fd43.png";